import React, { useEffect, useState } from "react";
import EventService from "../../services/EventService";

/**
 * "Add to calendar" (.ics) for Apple Calendar, Outlook and the like.
 *
 * The file is fetched up front and handed to the link as a blob rather than
 * pointing the link at the API origin. Two reasons, both mobile:
 *  - a cross-origin .ics navigation makes Safari show a download interstitial
 *    and then leaves the visitor on a blank api.kinprotect.com tab;
 *  - iOS only starts a download from a direct link activation, so the fetch
 *    cannot happen inside the click handler.
 * If the fetch fails the link falls back to the plain API URL.
 */
const AddToCalendarButton = ({
  slug,
  className = "ev-btn ev-btn-secondary",
  children = "Add to calendar",
}) => {
  const [blobUrl, setBlobUrl] = useState("");

  useEffect(() => {
    let active = true;
    let created = "";

    (async () => {
      const url = await EventService.fetchIcsBlobUrl(slug);
      if (!url) return;
      if (!active) {
        URL.revokeObjectURL(url);
        return;
      }
      created = url;
      setBlobUrl(url);
    })();

    return () => {
      active = false;
      if (created) URL.revokeObjectURL(created);
    };
  }, [slug]);

  return (
    <a
      className={className}
      href={blobUrl || EventService.icsUrl(slug)}
      download={EventService.icsFileName(slug)}
    >
      {children}
    </a>
  );
};

export default AddToCalendarButton;
